import { render, staticRenderFns } from "./howProtect.vue?vue&type=template&id=2d05263b&scoped=true"
import script from "./howProtect.vue?vue&type=script&lang=js"
export * from "./howProtect.vue?vue&type=script&lang=js"
import style0 from "./howProtect.vue?vue&type=style&index=0&id=2d05263b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d05263b",
  null
  
)

export default component.exports